import http from "../common/api";
import { ApiSettings } from "application";
import { getDocsFromServer } from "./adapter";

const get = async (userInfo) => {
  const response = await http.post(
    ApiSettings.getUnSignedDocuments,
    {
      bool: {
        must_not: [
          {
            term: {
              deleted: true,
            },
          },
        ],
        must: [
          {
            term: {
              enabled: true,
            },
          },
          {
            nested: {
              path: "signatory",
              query: {
                bool: {
                  must: [
                    {
                      term: {
                        "signatory.signatory_status": "Por Firmar",
                      },
                    },
                    {
                      term: {
                        "signatory.signatory_email": userInfo.email,
                      },
                    },

                    {
                      term: {
                        "signatory.signatory_rut": userInfo.rut,
                      },
                    },
                  ],
                },
              },
            },
          },
          {
            query_string: {
              default_field: "signers",
              query: `*${userInfo.rut.replace(
                /[.-]/g,
                ""
              )}_${userInfo.email.replace(/[@_.-]/g, "")}*`,
            },
          },
        ],
      },
    },
    { target: "alf" }
  );

  return getDocsFromServer(response);
};

export default get;
